import { useMutation, useQuery } from '@tanstack/react-query'
import { FormsHRReviewFlag } from '@viapeople/components'
import { trpc } from '../../../utils/trpc'
import type { ProcessedFormComponent } from './types'

interface HrReviewFlagComponentProps {
	component: ProcessedFormComponent
	evaluationId: string
	readOnly?: boolean
}

export function HrReviewFlagComponent({ component, evaluationId, readOnly }: HrReviewFlagComponentProps) {
	const formComponentId = component.id

	const existingFlagQuery = useQuery({
		...trpc.client.hrReviewFlags.getMyFlag.queryOptions({
			evaluationId,
			formComponentId,
		}),
		enabled: !!evaluationId && !!formComponentId,
	})

	const submitMutation = useMutation(
		trpc.client.hrReviewFlags.submit.mutationOptions({
			onSuccess: () => existingFlagQuery.refetch(),
		}),
	)

	return (
		<FormsHRReviewFlag
			component={component}
			readOnly={readOnly}
			existingFlag={existingFlagQuery.data ?? null}
			onSubmitFlag={async ({ reasonText }) => {
				await submitMutation.mutateAsync({
					evaluationId,
					formComponentId,
					reasonText,
				})
			}}
		/>
	)
}
